<div id="rd-cell" class="inner-page">
  <div class="container-fluid px-lg-5">
    <h2 class="title">Research and Development Cell</h2>

    <div class="mt-4">
      <h4 class="section-subtitle">Intellectual Property Rights (IPR)</h4>
      <p class="inner-lead">
        Our institution recognizes the vital role of Intellectual Property Rights (IPR) in fostering innovation and protecting the creative works of our faculty and students. We cover various forms of IPR, including patents, trademarks, copyrights, and trade secrets. The college provides active assistance in navigating the complexities of patent filings and intellectual property management.
      </p>
    </div>

    <div class="mt-4">
      <h4 class="section-subtitle">Copyright & Ownership</h4>
      <p class="inner-lead">
        The college maintains clear guidelines regarding the ownership of intellectual work. Generally, works created by employees within the scope of their employment are owned by the institution. However, students typically retain ownership of their theses and dissertations, unless specific prior agreements or external funding conditions exist.
      </p>
    </div>

    <div class="mt-4">
      <h4 class="section-subtitle">Research Ethics</h4>
      <p class="inner-lead">
        Integrity and ethics are at the core of all research activities at Shah Satnam Ji Girls' College. All research involving human subjects must undergo a rigorous review process by the Ethics Committee. We ensure that every project adheres to safety standards, participant anonymity, and informed consent protocols.
      </p>
    </div>

    <div class="mt-4">
      <h4 class="section-subtitle">Regulations & Management</h4>
      <p class="inner-lead">
        The R&D Cell oversees the management of all research projects, ensuring compliance with both institutional regulations and funding agency requirements. This includes budget oversight, progress tracking, and adherence to administrative guidelines for successful project completion.
      </p>
    </div>

  </div>
</div>
